import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorDirective } from '../../../Helpers/Directives/controlValueAccessor.directive';

@Component({
  selector: 'input-phone',
  templateUrl: './input-phone.component.html',
  styleUrls: ['./input-phone.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputPhoneComponent),
      multi: true,
    },
  ]
})
export class InputPhoneComponent extends ControlValueAccessorDirective {
  @Input() placeholder: string = '';
  @Input() public readonly: boolean = false;
  @Input() logo:string= ''
  @Input () prefix:string= '' 
  @Input () readOnly:boolean=false; 
  constructor() {
    super();
  }

  override change(){
    this.onChange('+966' + this.value)
  }
  override writeValue(obj:any){
    if(!obj) return super.writeValue(obj);
    let value:string = obj.toString();
    if(value.startsWith("+966") ){
      value = value.split("+966")[1]
    }
    super.writeValue(new Number(value));
  }
}
